import React from 'react';
import Form, { FormProps } from 'react-bootstrap/Form';

type Props = {
  title: string;
  details?: string;
  value?: string | number;
  min?: number;
} & FormProps;

const EditableParam = ({ title, value, onChange, placeholder, details, min }: Props) => (
  <Form.Group>
    <Form.Label>{details ? `${title} (${details})` : title}</Form.Label>
    {min !== undefined ? (
      // @ts-ignore
      <Form.Control type="number" min={min} value={value} placeholder={placeholder} onChange={onChange} />
    ) : (
      // @ts-ignore
      <Form.Control value={value} placeholder={placeholder} onChange={onChange} />
    )}
  </Form.Group>
);

export default EditableParam;
